export const secondsMs = 1000;
export const minutesMs = 60 * secondsMs;
export const hoursMs = 60 * minutesMs;
export const daysMs = 24 * hoursMs;
export const weeksMs = 7 * daysMs;
